import './button.css';

export default function Button({ children, onClick, disabled, style }) {
    return (
        <button
            type="button"
            className="mybutton"
            onClick={onClick}
            disabled={disabled}
            style={style}
        >
            {children}
        </button>
    );
}

